/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ email: NonNullable<unknown> }} Auth_Mfa_Email_Code_SentInputs */

const de_auth_mfa_email_code_sent = /** @type {(inputs: Auth_Mfa_Email_Code_SentInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ein Code wurde an ${i?.email} gesendet.`)
};

/** @type {(inputs: Auth_Mfa_Email_Code_SentInputs) => LocalizedString} */
const en_auth_mfa_email_code_sent = de_auth_mfa_email_code_sent;

/**

* @param {Auth_Mfa_Email_Code_SentInputs} inputs
* @param {{ locale?: "de" | "en" }} options
* @returns {LocalizedString}
*/
export const auth_mfa_email_code_sent = /** @type {((inputs: Auth_Mfa_Email_Code_SentInputs, options?: { locale?: "de" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Mfa_Email_Code_SentInputs, { locale?: "de" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_auth_mfa_email_code_sent(inputs)
	return en_auth_mfa_email_code_sent(inputs)
});